import { useContext } from 'react';
import { Edit } from 'react-feather';
import { Card, CardBody, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { BILL_MANAGEMENT_CONST, ValidationLabel } from '../../constant';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import LoaderResoinse from '../../loader/loader';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';
import { maxLengthCheck } from '../../utils/helper';

const BillAddModel = (props) => {
  const { onSubmit, close, error } = props;
  const { billModal, togglesubmit, billForm, setBillForm } = useContext(BillManagementContext);

  const { loaderShow } = useContext(OrganizationContext);
  const handelChange = (e) => {
    const { name, value } = e.target;
    setBillForm((prev) => {
      return {
        ...prev,
        [name]: value
      };
    });
  };
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setBillForm((prev) => ({
      ...prev,
      [name]: files[0] // store File object
    }));
  };

  const paymentType = ['CASH', 'UPI', 'BANK', 'CHEQUE'];

  return (
    <>
      <Modal size="lg" isOpen={billModal} toggle={() => close()}>
        {loaderShow === true && <LoaderResoinse />}
        <ModalHeader toggle={() => close()}>
          {togglesubmit ? (
            <span>{BILL_MANAGEMENT_CONST.ADD_BILL}</span>
          ) : (
            <span>
              {BILL_MANAGEMENT_CONST.EDIT_BILL} <span> </span>{' '}
              <Edit style={{ width: '50px', height: '20px', color: '#7366ff' }} />
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <Form className="needs-validation" onSubmit={(e) => onSubmit(e)}>
                    <Row>
                      <Col md="6 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={error && billForm.billDate?.length <= 0 ? 'validation' : 'non-validation'}
                        >
                          {error && billForm.billDate?.length <= 0
                            ? ValidationLabel.billRequired
                            : ValidationLabel.billDate}
                        </Label>
                        <Input
                          className={`${
                            error && billForm.billDate?.length <= 0 ? 'inputValidation' : ''
                          } "form-control`}
                          name="billDate"
                          type="date"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={billForm.billDate}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="6 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={error && billForm.totalAmount?.length <= 0 ? 'validation' : 'non-validation'}
                        >
                          {error && billForm.totalAmount?.length <= 0
                            ? ValidationLabel.totalAmountRequired
                            : ValidationLabel.totalAmount}
                        </Label>
                        <Input
                          className={`${
                            error && billForm.totalAmount?.length <= 0 ? 'inputValidation' : ''
                          } "form-control`}
                          name="totalAmount"
                          type="number"
                          placeholder="Bill Amount"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={billForm.totalAmount}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6 mb-4">
                        <Label htmlFor="validationCustom01" className={'non-validation'}>
                          {'Bill No'}
                        </Label>
                        <Input
                          className={`form-control`}
                          name="billNo"
                          type="number"
                          placeholder="Bill No"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={billForm.billNo}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="6 mb-4">
                        <Label htmlFor="validationCustom01" className={'non-validation'}>
                          {'Paid Amount'}
                        </Label>
                        <Input
                          className={`form-control`}
                          name="paidAmount"
                          type="number"
                          placeholder="Bill Amount"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={billForm.paidAmount}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="6 mb-4">
                        <Label htmlFor="validationCustom01">
                          {' '}
                          {error && billForm.paidAmount && billForm.paidAmount?.length <= 0
                            ? ValidationLabel.paymentModeRequired
                            : ValidationLabel.paymentMode}
                        </Label>
                        <select
                          className={`${
                            error && billForm.paidAmount && billForm.paymentMode?.length <= 0 ? 'inputValidation' : ''
                          } form-select`}
                          name="paymentMode"
                          typeof="number"
                          value={billForm.paymentMode}
                          onChange={handelChange}
                        >
                          <option value="">--select--</option>
                          {paymentType.map((elem) => {
                            return (
                              <option
                                value={elem}
                                key={elem}
                                selected={elem === billForm.paymentMode ? 'selected' : ''}
                              >
                                {elem}
                              </option>
                            );
                          })}
                        </select>
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="6 mb-4">
                        <Label htmlFor="validationCustom01" className={'non-validation'}>
                          {error && billForm.paidAmount && billForm.paidAmount?.length <= 0
                            ? ValidationLabel.referenceNoRequired
                            : ValidationLabel.referenceNo}{' '}
                        </Label>
                        <Input
                          className={`${
                            error && billForm.paidAmount && billForm.referenceNo?.length <= 0 ? 'inputValidation' : ''
                          } form-control`}
                          name="referenceNo"
                          type="number"
                          placeholder="Name"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={billForm.referenceNo}
                          onWheel={(e) => e.target.blur()}
                          min={0}
                          maxLength={10}
                          onInput={maxLengthCheck}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12 mb-4">
                        <Label htmlFor="validationCustom09">{'Notes'}</Label>
                        <textarea
                          className="form-control"
                          name="notes"
                          id="validationCustom09"
                          type="text"
                          placeholder="notes"
                          onChange={handelChange}
                          value={billForm.notes}
                        />
                        <div className="invalid-feedback">{'Please provide a valid State.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12 mb-4">
                        <Label htmlFor="validationCustom09">{'Bill Image'}</Label>
                        <Input
                          className="form-control"
                          name="billImage"
                          type="file"
                          id="validationCustom01"
                          onChange={handleFileChange}
                        />
                        <div className="invalid-feedback">{'Please provide a valid State.'}</div>
                      </Col>
                    </Row>

                    <Row style={{ paddingTop: '30px' }}>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        value="Submit"
                        disabled={loaderShow === true ? 'disabled' : ''}
                      >
                        {'Submit'}
                      </button>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default BillAddModel;
